// extracted by mini-css-extract-plugin
export var cartIcon = "_mz-0";
export var cartIconContainer = "_mz-1";